import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
	// 
	{
		path: '/',
		name: 'shop',
		component: () => import('../views/shop.vue')
	},
	{
		path: '/finish_order',
		name: 'shop',
		component: () => import('../views/finish_order.vue')
	},
	{
		path: '/home/register',
		name: 'home_register',
		component: () => import('../views/register.vue')
	},
	{
		path: '/home/forget',
		name: 'forget',
		component: () => import('../views/forget.vue')
	},
	{
		path: '/pages/login',
		name: 'index',
		component: () => import('../views/login.vue')
	},
	{
		path: '/user/info',
		name: 'index',
		component: () => import('../views/user_info.vue')
	},
	{
		path: '/user/address',
		name: 'index',
		component: () => import('../views/user_address.vue')
	},	
	{
		path: '/user/address/new',
		name: 'index',
		component: () => import('../views/user_addrees_new.vue')
	},
	{
		path: '/user/address/detail',
		name: 'index',
		component: () => import('../views/user_address_detail.vue')
	},
	{
		path: '/user/order',
		name: 'index',
		component: () => import('../views/user_order.vue')
	},
	{
		path: '/user/invoice',
		name: 'invoice',
		component: () => import('../views/user_invoice.vue')
	},
	{
		path: '/user/invoice/info',
		name: 'invoice_info',
		component: () => import('../views/user_invoice_info')
	},
	{
		path: '/user/invoice/new',
		name: 'invoice_new',
		component: () => import('../views/user_invoice_new')
	},
	{
		path: '/user/invoice/change',
		name: 'invoice_change',
		component: () => import('../views/user_invoice_change')
	},
	{
		path: '/user/invoice/list',
		name: 'invoice_list',
		component: () => import('../views/user_invoice_list')
	},
	
	
	

]

const router = new VueRouter({
	mode: 'hash',
	// mode: 'history',
	base: process.env.BASE_URL,
	routes
})


export default router